import { AbstractPmsApiService } from "./abstract.service";
import { Addon } from "../models";
import moment from 'moment';

/**
 * @class AddonPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Addon>}
 */
export class AddonPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/addon(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {Addon}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new Addon(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Addon>>}
     */
    get(params = {}, property = null) {
        
        const url = this.url({
            propertyId: property ? property.id : 0
        });
        
        const ignoreLB = params.hasOwnProperty('searchValue');
        
        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Addon} addon
     * @param {Property} property
     * @returns {Promise.<Addon>}
     */
    create(addon, property) {
        
        const url = this.url({
            propertyId: property.id
        });
        
        addon = addon.toObjectExcept('property', 'item');
        
        if (addon.intervals) {
            
            for (let model of addon.intervals) {
                
                model.start_date = moment(model.start_date).format('YYYY-MM-DD');
                model.end_date = moment(model.end_date).format('YYYY-MM-DD');
                
                //transform to sync pivot data
                if (angular.isArray(model.property_accommodation_types)) {
                    
                    let roomTypes = {};
                    
                    for (let type of model.property_accommodation_types) {
                        
                        roomTypes[type.id] = type.pivot;
                    }
                    
                    model.property_accommodation_types = roomTypes;
                }
            }
        }
        
        return this.http
            .post(url, addon, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Addon} addon
     * @returns {Promise.<Addon>}
     */
    update(addon) {
        
        const url = this.url({
            propertyId: addon.property.id,
            id: addon.id
        });
        
        return this.http
            .put(url, addon.toObjectExcept('property', 'item'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Addon} addon
     * @returns {Promise.<boolean>}
     */
    delete(addon) {
        
        const url = this.url({
            propertyId: addon.property.id,
            id: addon.id
        });
        
        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
    
    show(propertyId, addonId, params = {}) {
        
        const url = this.url({
            propertyId: propertyId,
            id: addonId
        });
        
      return this.http.get(url, {
            headers: this.authHeaders,
            params
        })
        .then(this.getModeler())
        .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Addon} addon
     * @returns {Promise.<boolean>}
     */
    moveUp(addon) {
        
        const url = this.url({
            propertyId: addon.property.id,
            id: addon.id
        });
        
        return this.http
            .get(url + '/up', {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Addon} addon
     * @returns {Promise.<boolean>}
     */
    moveDown(addon) {
        
        const url = this.url({
            propertyId: addon.property.id,
            id: addon.id
        });
        
        return this.http
            .get(url + '/down', {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    availableAddons(params = {}, property) {
        
        const url = this.url({propertyId: property.id}) + '/available-addons';
        
        return this.http
                   .post(url, params, {
                       headers: this.authHeaders
                   })
                   .then(this.getDataExtractor())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/addon.service.js